module.exports = __webpack_public_path__ + "803035cbfa7f10eed1f1eacd8a390109.svg";